/**
 * Master Kalender Hari Libur Nasional & Tanggal Merah Indonesia (SKB 3 Menteri)
 * Digunakan untuk:
 * 1. Presensi & Absensi (Karyawan tidak terhitung Alpa/Kosong saat tanggal merah)
 * 2. Kalender Kerja Satala & Pengurangan Hari Wajib Absen
 * 3. Tampilan Visual Kalender Presensi & Deteksi Tanggal Merah
 */

export const INDONESIAN_HOLIDAYS = {
  // === TAHUN 2025 ===
  '2025-01-01': 'Tahun Baru 2025 Masehi',
  '2025-01-27': 'Isra Mi\'raj Nabi Muhammad SAW',
  '2025-01-29': 'Tahun Baru Imlek 2576 Kongzili',
  '2025-03-29': 'Hari Suci Nyepi (Tahun Baru Saka 1947)',
  '2025-03-31': 'Hari Raya Idul Fitri 1446 H',
  '2025-04-01': 'Hari Raya Idul Fitri 1446 H',
  '2025-04-02': 'Cuti Bersama Idul Fitri 1446 H',
  '2025-04-03': 'Cuti Bersama Idul Fitri 1446 H',
  '2025-04-04': 'Cuti Bersama Idul Fitri 1446 H',
  '2025-04-07': 'Cuti Bersama Idul Fitri 1446 H',
  '2025-04-18': 'Wafat Yesus Kristus (Jumat Agung)',
  '2025-04-20': 'Hari Paskah',
  '2025-05-01': 'Hari Buruh Internasional',
  '2025-05-12': 'Hari Raya Waisak 2569 BE',
  '2025-05-29': 'Kenaikan Yesus Kristus',
  '2025-06-01': 'Hari Lahir Pancasila',
  '2025-06-06': 'Hari Raya Idul Adha 1446 H',
  '2025-06-27': 'Tahun Baru Islam 1447 H',
  '2025-08-17': 'Hari Kemerdekaan RI (HUT RI ke-80)',
  '2025-09-05': 'Maulid Nabi Muhammad SAW',
  '2025-12-25': 'Hari Raya Natal',
  '2025-12-26': 'Cuti Bersama Hari Raya Natal',

  // === TAHUN 2026 (TAHUN BERJALAN AKTIF) ===
  '2026-01-01': 'Tahun Baru 2026 Masehi',
  '2026-01-16': 'Isra Mi\'raj Nabi Muhammad SAW',
  '2026-02-17': 'Tahun Baru Imlek 2577 Kongzili',
  '2026-03-20': 'Hari Suci Nyepi (Tahun Baru Saka 1948)',
  '2026-03-21': 'Hari Raya Idul Fitri 1447 H',
  '2026-03-22': 'Hari Raya Idul Fitri 1447 H',
  '2026-03-23': 'Cuti Bersama Idul Fitri 1447 H',
  '2026-03-24': 'Cuti Bersama Idul Fitri 1447 H',
  '2026-04-03': 'Wafat Yesus Kristus (Jumat Agung)',
  '2026-04-05': 'Hari Paskah',
  '2026-05-01': 'Hari Buruh Internasional',
  '2026-05-14': 'Kenaikan Yesus Kristus',
  '2026-05-27': 'Hari Raya Idul Adha 1447 H',
  '2026-05-31': 'Hari Raya Waisak 2570 BE',
  '2026-06-01': 'Hari Lahir Pancasila',
  '2026-06-16': 'Tahun Baru Islam 1448 H',
  '2026-08-17': 'Hari Kemerdekaan RI (HUT RI ke-81)',
  '2026-08-25': 'Maulid Nabi Muhammad SAW',
  '2026-12-25': 'Hari Raya Natal',
  '2026-12-26': 'Cuti Bersama Hari Raya Natal',

  // === TAHUN 2027 ===
  '2027-01-01': 'Tahun Baru 2027 Masehi',
  '2027-01-06': 'Isra Mi\'raj Nabi Muhammad SAW',
  '2027-02-06': 'Tahun Baru Imlek 2578 Kongzili',
  '2027-03-10': 'Hari Raya Idul Fitri 1448 H',
  '2027-03-11': 'Hari Raya Idul Fitri 1448 H',
  '2027-03-26': 'Wafat Yesus Kristus',
  '2027-05-01': 'Hari Buruh Internasional',
  '2027-05-06': 'Kenaikan Yesus Kristus',
  '2027-05-17': 'Hari Raya Idul Adha 1448 H',
  '2027-05-20': 'Hari Raya Waisak 2571 BE',
  '2027-06-01': 'Hari Lahir Pancasila',
  '2027-06-06': 'Tahun Baru Islam 1449 H',
  '2027-08-17': 'Hari Kemerdekaan RI (HUT RI ke-82)',
  '2027-08-15': 'Maulid Nabi Muhammad SAW',
  '2027-12-25': 'Hari Raya Natal',
};

/**
 * Format Date object / string to YYYY-MM-DD
 */
export const formatDateKey = (dateInput) => {
  if (!dateInput) return '';
  if (typeof dateInput === 'string') {
    // If format is YYYY-MM-DD...
    if (dateInput.length >= 10 && dateInput.charAt(4) === '-' && dateInput.charAt(7) === '-') {
      return dateInput.slice(0, 10);
    }
  }
  const d = new Date(dateInput);
  if (isNaN(d.getTime())) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

/**
 * Cek apakah tanggal tertentu adalah Hari Libur Nasional / Tanggal Merah
 * @param {string|Date} dateInput 
 * @param {Array} customHolidays (opsional dari CompanySettings)
 * @returns {object|null} { isHoliday: true, name: string, type: 'nasional' | 'perusahaan' }
 */
export const getIndonesianHoliday = (dateInput, customHolidays = []) => {
  const key = formatDateKey(dateInput);
  if (!key) return null;

  // 1. Cek Libur Nasional Resmi
  if (INDONESIAN_HOLIDAYS[key]) {
    return {
      isHoliday: true,
      name: INDONESIAN_HOLIDAYS[key],
      type: 'nasional',
      dateStr: key
    };
  }

  // 2. Cek Custom Holiday Perusahaan (jika ada)
  if (Array.isArray(customHolidays)) {
    const custom = customHolidays.find(h => {
      const hDate = formatDateKey(h.date || h.tanggal || h);
      return hDate === key;
    });
    if (custom) {
      return {
        isHoliday: true,
        name: custom.name || custom.keterangan || custom.nama || 'Libur Perusahaan',
        type: 'perusahaan',
        dateStr: key
      };
    }
  }

  return null;
};

/**
 * Cek cepat boolean apakah suatu tanggal libur (Minggu / Libur Nasional)
 */
export const isHolidayOrSunday = (dateInput, isSatOff = false, customHolidays = []) => {
  const d = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;
  if (!d || isNaN(d.getTime())) return false;

  const day = d.getDay();
  if (day === 0) return true; // Minggu selalu libur
  if (day === 6 && isSatOff) return true; // Sabtu libur jika saturday_off

  return !!getIndonesianHoliday(dateInput, customHolidays);
};
